import { Injectable } from '@angular/core';
import { BaseService, ConfigService, LoggingService, PITEventService } from '@pit/core';
import { IDtoDepot, IDtoUser } from '@pit/frontend-model';
import { BehaviorSubject } from 'rxjs';
import { PinItTrackFrontendDataServicesAccessor } from '../../../module.data/accessor/implementations/pin.it.track.frontend.data.services.accessor';
import { PinItTrackFrontendEventHandlerService } from '../../../module.event/pin.it.track.frontend.event.handler.service';
import { PinItTrackFrontendEntityStoreFacadesAccessor } from '../../../module.store/accessor/pin.it.track.frontend.entity.store.facades.accessor';
import { IPinItTrackFrontendServicesAccessor } from '../interfaces/pin.it.track.frontend.services.accessor.interface';
import { PinItTrackFrontendCoreServicesAccessor } from './pin.it.track.frontend.core.services.accessor';

@Injectable({
    providedIn: 'root'
})
export class PinItTrackFrontendServicesAccessor extends BaseService implements IPinItTrackFrontendServicesAccessor {

    private _currentUser: IDtoUser = null;
    private _currentUser$: BehaviorSubject<IDtoUser> = new BehaviorSubject<IDtoUser>(null);
    private _selectedDepot: IDtoDepot = null;
    private _selectedDepot$: BehaviorSubject<IDtoDepot> = new BehaviorSubject<IDtoDepot>(null);


    constructor(configurationService: ConfigService, loggingService: LoggingService, eventService: PITEventService,
        coreServicesAccessor: PinItTrackFrontendCoreServicesAccessor, dataServicesAccessor: PinItTrackFrontendDataServicesAccessor,
        entityStoreFacadesAccessor: PinItTrackFrontendEntityStoreFacadesAccessor,
        private eventHandlerService: PinItTrackFrontendEventHandlerService) {
        super(configurationService, loggingService, false);

        this.eventService = eventService;
        this.coreServicesAccessor = coreServicesAccessor;
        this.dataServicesAccessor = dataServicesAccessor;
        this.entityStoreFacadesAccessor = entityStoreFacadesAccessor;
    }

    public get currentUser(): IDtoUser {
        return this._currentUser;
    }

    public set currentUser(value: IDtoUser) {
        if (value !== this.currentUser) {
            this._currentUser = value;

            this.dataServicesAccessor.currentUser = this.currentUser;
            this.entityStoreFacadesAccessor.currentUser = this.currentUser;

            this._currentUser$.next(this.currentUser);
        }
    }

    public get currentUser$(): BehaviorSubject<IDtoUser> {
        return this._currentUser$;
    }

    public get selectedDepot(): IDtoDepot {
        return this._selectedDepot;
    }

    public set selectedDepot(value: IDtoDepot) {
        if (value !== this.selectedDepot) {
            this._selectedDepot = value;

            this._selectedDepot$.next(this.selectedDepot);
        }
    }

    public get selectedDepot$(): BehaviorSubject<IDtoDepot> {
        return this._selectedDepot$;
    }

    public readonly coreServicesAccessor: PinItTrackFrontendCoreServicesAccessor = null;

    public readonly dataServicesAccessor: PinItTrackFrontendDataServicesAccessor = null;

    public readonly entityStoreFacadesAccessor: PinItTrackFrontendEntityStoreFacadesAccessor = null;

    public readonly eventService: PITEventService = null;

    protected override async doInitializeAsync(): Promise<void> {
        await super.doInitializeAsync();

        if (this.isInitialized === false) {
            await this.coreServicesAccessor.initializeAsync();
            await this.dataServicesAccessor.initializeAsync();
            await this.entityStoreFacadesAccessor.initializeAsync();
            await this.eventHandlerService.initializeAsync();

            this.coreServicesAccessor.authenticationService.currentUser$.subscribe(user => {
                this.currentUser = user;
            });
        }
    }

}
